import { render, staticRenderFns } from "./vademecum.vue?vue&type=template&id=314c2a4a"
import script from "./vademecum.vue?vue&type=script&lang=js"
export * from "./vademecum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports